import React, { CSSProperties, useEffect, useState } from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import { isIPhone } from 'Utilities/devices';

import { Content } from 'LegacySBCRA/Content/Content';

import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';
import { MandatoryInfoBox } from '../MandatoryInfoBox/MandatoryInfoBox';
import { VehicleHubProgressBar } from '../ProgressBar/VehicleHubProgressBar';
import { SWITCH_TIME } from '../VehicleProfiling.constants';

import styles from './QuestionBody.module.scss';

const fadeOutTime = ((SWITCH_TIME % 60000) / 1000).toFixed(2);

type QuestionBodyProps = {
  animateOnEnd?: boolean;
  animateOnStart?: boolean;
  centered?: boolean;
  children?: React.ReactNode;
  className?: ClassNameType;
  withoutProgressBar?: boolean;
};

export const QuestionBody = ({
  animateOnEnd = false,
  animateOnStart = false,
  centered = true,
  children,
  className,
  withoutProgressBar = false,
}: QuestionBodyProps) => {
  const [isBodyScrolled, setIsBodyScrolled] = useState(false);

  const breakpoints = useBreakpoint();
  const tabletBreakpoint = breakpoints.maxWidth.breakpointTablet;

  useEffect(() => {
    if (!isIPhone()) {
      return;
    }

    const handleScroll = () => {
      setIsBodyScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!children) {
    return null;
  }

  return (
    <Content
      center={centered}
      className={cx(styles.component, className, {
        [styles.animate]: animateOnStart,
        [styles.animateEnd]: animateOnEnd,
        [styles.isScrolled]: isBodyScrolled,
      })}
      style={{ '--question-body-fade-time': `${fadeOutTime}s` } as CSSProperties}
    >
      {!withoutProgressBar && tabletBreakpoint
        && <VehicleHubProgressBar className={cx(styles.progressBar, styles.withoutTranslate)}
        />}
      <MandatoryInfoBox />
      {children}
    </Content>
  );
};
